import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import vw from 'src/styles/utils';

function Input(props) {
  const {
    label,
    gridArea,
    required,
    disabled,
    id,
    hidden,
    type,
    restriction,
    value,
    accept,
    placeholder,
    validation,
    handleonBlur,
    handleonChange,
  } = props;

  return (
    <Root gridArea={gridArea} hidden={hidden} className={validation}>
      <label htmlFor={id}>{label}</label>
      <input
        type={type}
        id={id}
        name={id}
        required={required}
        disabled={disabled}
        pattern={restriction}
        accept={accept}
        value={value}
        placeholder={placeholder}
        onBlur={handleonBlur}
        onChange={handleonChange}
      />
    </Root>
  );
}

Input.propTypes = {
  label: PropTypes.string,
  gridArea: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  restriction: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  accept: PropTypes.string,
  placeholder: PropTypes.string,
  validation: PropTypes.string,
  handleonBlur: PropTypes.func,
  handleonChange: PropTypes.func,
};

const Root = styled.div`
  display: ${(props) => (props.hidden ? 'none' : 'flex')};
  flex-direction: column;
  grid-area: ${(props) => props.gridArea};
  label {
    font-family: Gotham Book;
    font-style: normal;
    font-weight: normal;
    color: #000000;
    text-align: left;
    ${vw('font-size', 14, 12)}
    ${vw('line-height', 17, 19)}
    ${vw('letter-spacing', 0.06)}
    ${vw('margin-bottom', 5, 3)}
  }
  .error label {
    color: red;
  }
  input {
    border: 1px solid #e1e1e1;
    box-sizing: border-box;
    color: #747474;
    ${vw('height', 30)}
    ${vw('font-size', 13, 15)}
    ${vw('line-height', 10, 16)}
    ${vw('letter-spacing', 0.06)}
    ${vw('padding-left', 3, 5)}
  }
  input:disabled {
    opacity: 0.5;
    background: #e1e1e1;
  }
`;

export default Input;
